export enum AvailableCountries {
  BRAZIL = 'br',
  MEXICO = 'mx',
}

// SAR report families (report_type_family). Distinct from AlertDecision.SUSPICIOUS,
// which is an alert triage decision that happens to share the string.
export enum SarReportFamily {
  SUSPICIOUS = 'suspicious',
}

/** Final committee deliberation. Return-to-edit is a stage transition, not a decision. */
export enum SarCommitteeDecision {
  APPROVE = 'approve',
  DISMISS = 'dismiss',
}

export enum RegulatoryType {
  COAF = 'coaf',
  CNBV = 'cnbv',
  UIF = 'uif',
  FINCEN = 'fincen',
}

export enum LifecycleStatus {
  DRAFT = 'draft',
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}

export enum RunnabilityStatus {
  ACTIVE = 'active',
  DEPRECATED = 'deprecated',
  ARCHIVED = 'archived',
  NOT_FOUND = 'not_found',
}

export enum EntityType {
  PERSON = 'person',
  COMPANY = 'company',
}

export type TimeUnit = 'days' | 'months' | 'years';
export type KyxRiskModelEntityRelationship = string;

export enum TaxIdStatusDescription {
    REGULAR = "REGULAR",
    PENDING_REGULARIZATION = "PENDENTE DE REGULARIZACAO",
    SUSPENSA = "SUSPENSA",
    CANCELED = "CANCELADA",
    NULL = "NULA",
    DECEASED_HOLDER = "TITULAR FALECIDO",
    CPF_NOT_FOUND_IN_RECEITA = "CPF DOES NOT EXIST IN RECEITA FEDERAL DATABASE",
}

/** `detail.code` of the 422 the person basic-data endpoint returns when the data provider answered with an error. */
export enum PersonBasicDataProviderError {
    MINOR = "person_basic_data.minor",
    OTHER = "person_basic_data.provider_error",
}

export enum MaritalStatus {
    SINGLE = "Solteiro(a)",
    MARRIED = "Casado(a)",
    DIVORCED = "Divorciado(a)",
    WIDOWED = "Viúvo(a)",
    LEGALLY_SEPARATED = "Separado(a) Judicialmente",
    STABLE_UNION = "União Estável",
}

export enum Gender {
    MALE = "MASCULINO",
    FEMALE = "FEMININO",
}

export enum WorkflowEntityType {
    ALERT = "alert",
    INVESTIGATION = "investigation",
    SAR_SUSPICIOUS = "sar_suspicious",
    KYC_PARECER = "kyc_parecer",
}

export enum ActionType {
    ADD = 'add',
    UPDATE = 'update',
    DELETE = 'delete',
}

// Internal pipeline status (mirrors backend IngestionStatus). Prefer IngestionDisplayStatus
// for anything user-facing — these values are pipeline internals.
export enum IngestionStatus {
  UPLOAD_LINK_CREATED = 'upload_link_created',
  UPLOADED_TO_STORAGE = 'uploaded_to_storage',
  RAW_LOAD_COMPLETED = 'raw_load_completed',
  RAW_TRANSACTIONS = 'raw_transactions',
  FAILED = 'failed',
  EXPIRED = 'expired',
}

// User-facing rollup derived server-side (mirrors backend IngestionDisplayStatus).
export enum IngestionDisplayStatus {
  AWAITING_UPLOAD = 'awaiting_upload',
  PROCESSING = 'processing',
  ANALYZING = 'analyzing',
  COMPLETED = 'completed',
  FAILED = 'failed',
  EXPIRED = 'expired',
}

export enum IngestionFileCategory {
  TRANSACTIONS = 'transactions',
  CUSTOMER_BASE = 'customer_base',
}

export enum TransactionPartiesRepresentation {
  SENDER_RECEIVER = 'sender_receiver',
  ACCOUNT_HOLDER = 'account_holder',
}

export enum FinancialCapacityBucket {
    UP_TO_100K = "up_to_100k",
    FROM_100K_TO_500K = "from_100k_to_500k",
    FROM_500K_TO_1M = "from_500k_to_1m",
    FROM_1M_TO_5M = "from_1m_to_5m",
    FROM_5M_TO_10M = "from_5m_to_10m",
    ABOVE_10M = "above_10m",
}


export enum Currency{
    BRL='BRL'
  }

export enum PlanType {
  PAID = 'paid',   // Real, revenue-generating commercial plan
  DEMO = 'demo',   // Trial / demo plan
}

// The four top-level folders in the bucket. Mirrors FileCategory in
// backend/schemas/enums.py.
export enum FileCategory {
  UPLOAD = 'upload',
  GENERATE = 'generate',
  INGESTION = 'ingestion',
  EXPORTS = 'exports',
}

// Mirrors UploadKind in backend/schemas/enums.py: the only kinds POST /files/upload
// accepts, because that is the type of its `kind` parameter. The backend builds the rest
// of the storage path, so the client never sends one.
//
// A TypeScript string enum only takes literal initializers, so unlike the backend these
// cannot interpolate FileCategory.UPLOAD. Keep the prefixes in step with it.
export enum UploadKind {
  INVESTIGATIONS = 'upload/investigations',
  KYC_PARECERS = 'upload/kyc-parecers',
  GLOBAL_SCREENING_DECISIONS = 'upload/global-screening-decisions',
  KYC_BATCHES = 'upload/kyc-batches',
  SPEARWATCH_RESULTS = 'upload/spearwatch-results',
}
